import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplicationProcessApi from 'api/curo/ApplicationProcessApi';
import { ApplicationProcessActionTypes } from 'enums/curo/ApplicationProcessActionTypes';

export const createHandleOrganicLoanOfferViewedThunk = (api: ApplicationProcessApi) =>
  createAsyncThunk(
    ApplicationProcessActionTypes.HandleOrganicLoanOfferViewed,
    async ({ applicationId }: { applicationId: string }) => {
      const response = await api.handleOrganicLoanOfferViewed(applicationId);
      return response;
    },
  );
